// English strings (source language): Friends screen.

const en = {
  title: 'Friends',
  offline: 'Server unreachable: friends need the Gruvetto server.',
  noRide: 'no rides',
  copied: (what: string) => `${what} copied`,
  inviteTitle: 'Friend invitation',
  nowFriends: (name: string) => `You are now friends with ${name}!`,
  requestSent: (name: string) => `Request sent to ${name}`,
  introShort: 'Add your buddies, follow their rides and compare.',
  friendBadge: 'Friend',
  sentBadge: 'Request sent',
  accept: 'Accept',
  add: 'Add',
  intro: 'Add your buddies, follow their rides and compare yourselves in the leaderboards.',
  friendsBoard: 'Friends leaderboard',
  incoming: 'Requests received',
  decline: 'Decline',
  requested: (when: string) => `requested ${when}`,
  myFriends: 'My friends',
  remove: (name: string) => `Remove ${name}`,
  lastRide: (when: string) => `last ride ${when}`,
  watch: 'Watch',
  liveRacing: 'Racing now',
  liveRoom: 'In a room',
  noFriends: 'No friends yet. Share your code or search for a player by name.',
  feed: 'Their latest rides',
  feedEmpty: 'Your friends haven’t ridden yet.',
  feedNoFriends: 'Your friends’ rides will show up here.',
  yourCode: 'Your friend code',
  codeHelp: 'Give this code to a friend, or send them the link: they just need to open it.',
  copyCode: 'Copy code',
  copyLink: 'Copy invite link',
  addFriend: 'Add a friend',
  searchPlaceholder: 'Name or friend code',
  search: 'Search',
  noResult: 'No player found.',
  outgoing: 'Requests sent',
  pending: (when: string) => `pending · ${when}`,
  code: 'Code',
  link: 'Link',
  accepted: 'Request accepted',
  cancelled: 'Request cancelled',
  declined: (name: string) => `Request from ${name} declined`,
  removeAsk: (name: string) => `Remove ${name} from your friends?`,
  removeBtn: 'Remove',
  removed: (name: string) => `${name} removed from your friends`,
};
export default en;
